import React, { useEffect, useState } from "react";
import {
  Input,
  Row,
  Card,
  Form,
  Col,
  Typography,
  Select,
  Button,
  Layout,
  Image,
  notification,
} from "antd";
import { isEmpty, isPlainObject, isUndefined } from "lodash";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import actions from "../../redux/studentDetails/actions";
import config from "../../Services/apiEndPoints";
import "../../Screens/form.css";
import { genderList } from "./const";

const { Option } = Select;
const { TextArea } = Input;
const { Header } = Layout;

export default function PersonalDetails() {
  const dispatch = useDispatch();
  const { successMessage, errorMessage, actionType, studentDetails } =
    useSelector((state) => state.student);
  const navigate = useNavigate();
  const [personForm] = Form.useForm();
  const mobileNum = localStorage.getItem("mobileNumber");
  const [student_Id, setStudentId] = useState(
    localStorage.getItem("Student_Id")
  );

  useEffect(() => {
    if (!isEmpty(student_Id) && !isUndefined(student_Id)) {
      dispatch(
        actions.getStudentPersonalDetails(
          `${config.studentGet}?studentId=${student_Id}`
        )
      );
    }
  }, []);

  useEffect(() => {
    if (isPlainObject(studentDetails) && !isEmpty(studentDetails)) {
      personForm.setFieldsValue({
        ...studentDetails,
      });
    }
  }, [studentDetails]);

  useEffect(() => {
    if (
      actionType === actions.STUDENT_PERSONAL_DETAILS_CREATE_SUCCESS ||
      actionType === actions.STUDENT_DETAILS_UPDATE_SUCCESS
    ) {
      notification.success({
        message: successMessage,
      });
      navigate("/schoolDetails");
      dispatch(actions.resetStudentPersonalDetails());
    } else if (
      actionType === actions.STUDENT_PERSONAL_DETAILS_CREATE_ERROR ||
      actionType === actions.STUDENT_DETAILS_UPDATE_ERROR
    ) {
      notification.error({
        message: errorMessage,
      });
      dispatch(actions.resetStudentPersonalDetails());
    }
  }, [actionType, successMessage, errorMessage]);

  const handleSave = async () => {
    try {
      const values = await personForm.validateFields();
      if (!isEmpty(student_Id) && !isUndefined(student_Id)) {
        values["id"] = student_Id;
        dispatch(actions.updateStudentDetails(config.studentUpdate, values));
      } else {
        values["mobile_number"] = mobileNum;
        dispatch(
          actions.createStudentPersonalDetails(config.studentCreate, values)
        );
      }
    } catch (e) {
      console.log(e);
    }
  };

  const handleNewStudent = () => {
    personForm.resetFields();
    localStorage.removeItem("Student_Id");
    setStudentId(null);
    dispatch(actions.resetStudentPersonalDetails());
  };

  return (
    <>
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundImage:
            "url(https://easy-peasy.ai/cdn-cgi/image/quality=80,format=auto,width=700/https://fdczvxmwwjwpwbeeqcth.supabase.co/storage/v1/object/public/images/889e1b27-b887-4082-a896-b7921854ef78/722b627e-72e3-4422-80a7-aab78de2256e.png)",
          backgroundPosition: "center",
          backgroundSize: "cover",
          zIndex: -1,
        }}
      >
        <div>
          <Header style={{ backgroundColor: "#ffb948", height: "75px" }}>
            <Row align="middle" gutter={16}>
              <Col xs={8} sm={6} md={4} lg={6}>
                <a
                  href="https://sriramanavami.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Image
                    preview={false}
                    src="/favicon.ico"
                  />
                </a>
              </Col>
            </Row>
          </Header>
        </div>

        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Row>
            <Card
              style={{
                width: "100%",
                maxWidth: "800px",
                borderRadius: "8px",
                boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
                boxShadow: "0 10px 15px 0 rgba(10,1,10,10)",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  width: "100%",
                  marginBottom: "1px",
                }}
              >
                <Typography.Title
                  level={3}
                  style={{
                    textAlign: "left",
                    margin: 0,
                  }}
                >
                  Personal Details
                </Typography.Title>

                {isPlainObject(studentDetails) && !isEmpty(studentDetails) && (

                <Button
                  type="primary"
                  style={{
                    backgroundColor: "#ffb948",
                    color: "white",
                    border: "none",
                    width: "130px",
                  }}
                  onClick={handleNewStudent}
                >
                  + Add Student
                </Button>
                )}
              </div>

              <Form form={personForm} layout="vertical">
                <Row gutter={24}>
                  <Col xs={24} sm={12} md={8}>
                    <Form.Item
                      name="name"
                      label="Student Name"
                      rules={[
                        {
                          required: true,
                          message: "Student name is required.",
                        },
                      ]}
                    >
                      <Input
                        placeholder="Enter Name"
                        className="custom-input"
                        disabled={isPlainObject(studentDetails) && !isEmpty(studentDetails)}
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={12} md={8}>
                    <Form.Item
                      label="Age"
                      name="age"
                      rules={[
                        {
                          required: true,
                        },
                      ]}
                    >
                      <Input
                        type="number"
                        placeholder="Enter age"
                        className="custom-input"
                        disabled={isPlainObject(studentDetails) && !isEmpty(studentDetails)}
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={12} md={8}>
                    <Form.Item
                      name="gender"
                      label="Gender"
                      rules={[
                        {
                          required: true,
                          message: "Gender is required.",
                        },
                      ]}
                    >
                      <Select
                        showSearch
                        placeholder="Select Gender"
                        optionFilterProp="label"
                        onSelect={(item) => {
                          console.log("item", item);
                        }}
                        className="custom-select"
                        disabled={isPlainObject(studentDetails) && !isEmpty(studentDetails)}
                      >
                        {genderList.map((item, index) => (
                          <Option
                            key={index}
                            value={item.label}
                            label={item.label}
                          >
                            {item.label}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={24}>
                  <Col xs={24} sm={12} md={8}>
                    <Form.Item
                      name="fatherormother_name"
                      label="Father/Mother Name"
                    >
                      <Input
                        placeholder="Enter Name"
                        className="custom-input"
                        disabled={isPlainObject(studentDetails) && !isEmpty(studentDetails)}
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={12} md={8}>
                    <Form.Item label="Email" name="email">
                      <Input
                        placeholder="Enter your email"
                        className="custom-input"
                        disabled={isPlainObject(studentDetails) && !isEmpty(studentDetails)}
                      />
                    </Form.Item>
                  </Col>
                </Row>
                <Typography.Title level={5}>Address Details</Typography.Title>
                <Row gutter={24}>
                  <Col xs={24} sm={12} md={8}>
                    <Form.Item
                      label="Address Line 1"
                      name={["address", "address1"]}
                      rules={[
                        {
                          required: true,
                          message: "Please enter Address Line 1.",
                        },
                      ]}
                    >
                      <TextArea
                        maxLength={100}
                        placeholder="Enter Address Line 1"
                        className="custom-input"
                        disabled={isPlainObject(studentDetails) && !isEmpty(studentDetails)}
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={12} md={8}>
                    <Form.Item
                      label="Address Line 2"
                      name={["address", "address2"]}
                    >
                      <TextArea
                        maxLength={100}
                        placeholder="Enter Address Line 2"
                        className="custom-input"
                        disabled={isPlainObject(studentDetails) && !isEmpty(studentDetails)}
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={12} md={8}>
                    <Form.Item
                      label="Address Line 3"
                      name={["address", "address3"]}
                    >
                      <TextArea
                        maxLength={100}
                        placeholder="Enter Address Line 3"
                        className="custom-input"
                        disabled={isPlainObject(studentDetails) && !isEmpty(studentDetails)}
                      />
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={24}>
                  <Col xs={24} sm={12} md={8}>
                    <Form.Item
                      name={["address", "city"]}
                      label="City"
                      rules={[{ required: true, message: "City is required" }]}
                    >
                      <Input
                        placeholder="Enter City"
                        className="custom-input"
                        disabled={isPlainObject(studentDetails) && !isEmpty(studentDetails)}
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={12} md={8}>
                    <Form.Item
                      name={["address", "pincode"]}
                      label="Pincode"
                      rules={[
                        { required: true, message: "Pincode is required" },
                      ]}
                    >
                      <Input
                        placeholder="Enter Pincode"
                        className="custom-input"
                        disabled={isPlainObject(studentDetails) && !isEmpty(studentDetails)}
                      />
                    </Form.Item>
                  </Col>
                </Row>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                  }}
                >
                  <Button
                    type="primary"
                    style={{
                      width: "15%",
                      backgroundColor: "#ffb948", // Button color matches header
                      color: "white",
                      border: "none",
                    }}
                    onClick={handleSave}
                  >
                    Next
                  </Button>
                </div>
              </Form>
            </Card>
          </Row>
        </div>
      </div>
    </>
  );
}
